// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1o-ll","title":"Images45_title__zTQCu","images":"Images45_images__f10qu"};